import { create } from 'zustand';

// ============================================================
// 项目部署对话框状态（DW-P0-8）：任意入口 openModal(target) 打开
// ============================================================

export interface DeployTarget {
  kind: 'scene' | 'dashboard' | 'fusion';
  sceneId?: string;
  pageId?: string;
  name?: string;
}

interface DeployState {
  open: boolean;
  target: DeployTarget | null;
  openModal: (target: DeployTarget) => void;
  close: () => void;
}

export const useDeployStore = create<DeployState>((set) => ({
  open: false,
  target: null,
  openModal: (target) => set({ open: true, target }),
  close: () => set({ open: false }),
}));
